import React from 'react';
import HeaderDashboard from '../Components/HeaderDashboard'

const ManageMarkup = () => (
    <>
     <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Settings</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/settings/ManageMarkup" className="text-muted text-hover-primary">Manage Markup</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        
        <section className='wraper'>
            <div className='box_shadow mt-14'>
                <h6>Change Password</h6>
                <div className='row mt-10'>
                    <div class="col-md-3 mb-3">
                         <label className='required'>Old Password</label>
                    <input class="form-control form-control-solid" type="password" placeholder='Old Password' />
                    </div>
                    <div class="col-md-3 mb-3">
                        <label className='required'>New Password</label>
                    <input class="form-control form-control-solid" type="password" placeholder='New Password' />
                    </div>
                    <div class="col-md-3 mb-3">
                         <label className='required'>Confirm Password</label>
                    <input class="form-control form-control-solid" type="password" placeholder='Confirm Password' />
                    </div>
                    <div class="col-md-3 mt-8">
                        <button className='btn btn-primary'>Update</button>
                        </div>
                </div>
            </div>


        </section>

    </>
);

export default ManageMarkup;